import { FileUtils } from "../../../../../common/utils/file_utils";
import { IUpdateObraUseCase } from "../../../presentation/useCases/update/update_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateObraUseCase
 */

export class UpdateObraUseCase implements IUpdateObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateObra(
    idObra: number,
    tipo: number,
    idFuncionarioAprovado: number | null,
    idFuncionarioRevisado: number | null,
    idCentroCusto: number | null,
    idEmpreendimento: number | null,
    historicoRevisoes: string | null,
    apresentacaoObra: string | null,
    processo: string | null,
    pctPdeFadDatec: string | null,
    meios: string | null,
    imgEo: string | null,
    imgCo: string | null,
    estOrgFileUpload: File | null,
    cantFileUpload: File | null,
  ): Promise<void> {
    const extEo = estOrgFileUpload ? estOrgFileUpload.name.substring(estOrgFileUpload.name.lastIndexOf('.') + 1) : null;
    const extCo = cantFileUpload ? cantFileUpload.name.substring(cantFileUpload.name.lastIndexOf('.') + 1) : null;

    const estOrgFile = await FileUtils.readFileAsBase64(estOrgFileUpload);
    const cantFile = await FileUtils.readFileAsBase64(cantFileUpload);

    const limparEo = imgEo === null && estOrgFileUpload === null;
    const limparCo = imgCo === null && cantFileUpload === null;

    await this.repository.updateObra(
      idObra,
      tipo,
      idFuncionarioAprovado,
      idFuncionarioRevisado,
      idCentroCusto,
      idEmpreendimento,
      historicoRevisoes,
      apresentacaoObra,
      processo,
      pctPdeFadDatec,
      meios,
      estOrgFile,
      cantFile,
      extEo,
      extCo,
      limparEo,
      limparCo,
    );
  }
}
